export const ValidationAlphabetLocale: { [key: string]: string } = {
    'danish': 'danish',
    'french': 'french',
    'german': 'german',
    'greek': 'greek',
    'spanish': 'spanish',
    'russian': 'russian'
}